import * as React from 'react';
import Moment from 'react-moment';

interface DisplayDateExpiryTypes {
	children?: string | number | Date | moment.Moment;
}

export const DisplayDateExpiry: React.FC<DisplayDateExpiryTypes> = ({ children }) => {
	return (
		<Moment format="DD/MM/YYYY" parse="YYYY-MM-DDTHH:mm:ss.SSSSSSSZ">
			{children}
		</Moment>
	);
};

export default DisplayDateExpiry;
